/**
 * CLI handler for `nexus logs`.
 * Tails the log file in real time (requires LOG_FILE env var).
 */

import { existsSync } from 'node:fs'
import { resolve } from 'node:path'
import { spawn } from 'node:child_process'
import { consola } from 'consola'

export async function handleLogs(options: { lines?: string; file?: string }): Promise<void> {
  const logFile = options.file || process.env['LOG_FILE'] || resolve('data', 'nexus.log')

  if (!existsSync(logFile)) {
    consola.error(`Log file not found: ${logFile}`)
    consola.info('Set LOG_FILE in .env to enable file logging, then restart the server.')
    process.exit(1)
  }

  const lines = options.lines || '50'
  consola.info(`Tailing: ${logFile}`)

  const tail = spawn('tail', ['-n', lines, '-f', logFile], {
    stdio: 'inherit',
  })

  tail.on('error', (err) => {
    consola.error(`Failed to tail logs: ${err.message}`)
    process.exit(1)
  })

  process.on('SIGINT', () => {
    tail.kill()
    process.exit(0)
  })
}
